const getMemberCount = (team, seatsCount) => {
  const memberCount = team?.team?.memberTeams?.length;
  const quantity = team?.team?.initialQuantity > seatsCount ?? 0 ? team?.team?.initialQuantity : seatsCount;

  return memberCount > quantity ? memberCount : quantity;
};

export default getMemberCount;
